import { forwardRef } from 'react';
import Styles from './FJAiToolsCategory.module.less';
import FJZoomInPreview from './items/FJZoomInPreview';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJVideoPlayerPreview from './items/FJVideoPlayerPreview';
import FJComparePreview from './items/FJComparePreview';
import FJVideoComparePreview from './items/FJVideoComparePreview';
import PropTypes from 'prop-types';
import FJUtil from '../../../../../util/FJUtil';
import { AI_TOOLS_RESOURCE_PATH } from '../../../../../config/dataConfig/FJCommunityData';
import useLocalStore from '../../../../../hooks/useLocalStore.js';

const FJAiToolsCategory = (props, ref) => {
    useLocalStore();
    const { categoryName, list, isHot } = props;

    const _renderItems = () => {
        return list.map(item => {
            const { name, hoverEffect, source = [], jumpLink, sourceType = 'image' } = item;
            const jumpUrl = `${FJUtil.getCurrentUrl()}${jumpLink}`;
            switch (hoverEffect) {
                case 'play video': {
                    return (
                        <FJVideoPlayerPreview
                            key={name}
                            name={name}
                            imgUrl={AI_TOOLS_RESOURCE_PATH + source[0]}
                            videoUrl={AI_TOOLS_RESOURCE_PATH + source[1]}
                            jumpLink={jumpUrl}
                        />
                    );
                }
                case 'compare': {
                    if (sourceType === 'video') {
                        return (
                            <FJVideoComparePreview
                                key={name}
                                name={name}
                                beforeUrl={AI_TOOLS_RESOURCE_PATH + source[0]}
                                afterUrl={AI_TOOLS_RESOURCE_PATH + source[1]}
                                jumpLink={jumpUrl}
                            />
                        );
                    }
                    return (
                        <FJComparePreview
                            key={name}
                            name={name}
                            beforeUrl={AI_TOOLS_RESOURCE_PATH + source[0]}
                            afterUrl={AI_TOOLS_RESOURCE_PATH + source[1]}
                            jumpLink={jumpUrl}
                        />
                    );
                }
                default:
                    return (
                        <FJZoomInPreview
                            key={name}
                            name={name}
                            url={AI_TOOLS_RESOURCE_PATH + source[0]}
                            jumpLink={jumpUrl}
                        />
                    );
            }
        });
    };
    return (
        <div className={Styles.box} ref={ref}>
            <div className={Styles.header}>
                <div className={Styles.categoryName}>{FJLocalStore._(categoryName)}</div>
                {isHot && <div className={Styles.hotMark}>{FJLocalStore._('hot')}</div>}
            </div>
            <div className={Styles.content}>{_renderItems()}</div>
        </div>
    );
};

FJAiToolsCategory.propTypes = {
    categoryName: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    isHot: PropTypes.bool.isRequired,
};
export default forwardRef(FJAiToolsCategory);
